import React from 'react'

const MwInputText = (props) => {
    const {id,value='',defaultValue,onChange,readOnly,disabled,label,invalid,invalidMsg,placeholder,size,onKeyDown,classNameInput,inputRef,inputType='text'} = props
    const inputClass = `finance-input flex-1 w-full rounded-md border bg-white px-3 text-center text-xs text-[#261759] outline-none transition ${size === 'sm' ? 'h-7' : 'h-9'} ${invalid ? 'border-red-500 focus:border-red-600 focus:ring-red-100' : 'border-[#d7dce3] focus:border-[#261759] focus:ring-[#e7f7d6]'} focus:ring-2 disabled:bg-[#f1f5f9] disabled:text-[#8b93a1] ${classNameInput || ''}`;
    return (
        <>
            { label && 
                <label className='finance-label block text-xs px-1 text-[#261759] font-semibold pb-1' htmlFor={id}>{label}</label>}
            
            { inputRef ?
            <input 
                ref={inputRef}
                type={inputType}
                className={inputClass}
                readOnly={readOnly}
                disabled={disabled}
                placeholder={placeholder}
                defaultValue={defaultValue} 
                onChange={onChange}
                onKeyDown={onKeyDown}
            />
            :<input 
                type={inputType}
                className={inputClass}
                name={id} 
                value={value}  
                onChange={onChange} 
                onKeyDown={onKeyDown}
                readOnly={readOnly}
                disabled={disabled}
                placeholder={placeholder}
                />}
            { invalidMsg && <div className='text-xs text-red-600 mt-1'>{invalidMsg}</div> }
        </>
    )
}

export default MwInputText
